// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrFieldDto } from './IOcrFieldDto';
import {
    IOcrFieldDtoFromJSON,
    IOcrFieldDtoFromJSONTyped,
    IOcrFieldDtoToJSON,
    IOcrFieldDtoToJSONTyped,
} from './IOcrFieldDto';

/**
 * 
 * @export
 * @interface IOcrFieldStateDto
 */
export interface IOcrFieldStateDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrFieldStateDto
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrFieldStateDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrFieldStateDto
     */
    confidence?: string;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrFieldStateDto
     */
    options?: Array<IOcrFieldDto>;
}

/**
 * Check if a given object implements the IOcrFieldStateDto interface.
 */
export function instanceOfIOcrFieldStateDto(value: object): value is IOcrFieldStateDto {
    return true;
}

export function IOcrFieldStateDtoFromJSON(json: any): IOcrFieldStateDto {
    return IOcrFieldStateDtoFromJSONTyped(json, false);
}

export function IOcrFieldStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrFieldStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'state': json['state'] == null ? undefined : json['state'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(IOcrFieldDtoFromJSON)),
    };
}

export function IOcrFieldStateDtoToJSON(json: any): IOcrFieldStateDto {
    return IOcrFieldStateDtoToJSONTyped(json, false);
}

export function IOcrFieldStateDtoToJSONTyped(value?: IOcrFieldStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'state': value['state'],
        'confidence': value['confidence'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(IOcrFieldDtoToJSON)),
    };
}

